import React, {InputHTMLAttributes, useRef} from 'react'
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  placeholder: any
  title: any
  error?: any
  required?: boolean
}

export const Input: React.FC<InputProps> = ({...rest}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <div className='row mb-3'>
      <label className={`col-lg-2 col-form-label fw-bold  ${rest.required ? 'required' : ''}`}>
        {rest.title}
      </label>

      <div className='col-lg-10'>
        <div className='row'>
          <div className='col-lg-12 fv-row'>
            <input
              type={rest.type}
              className='form-control form-control-sm form-control-solid mb-3 mb-lg-0'
              size={100}
              ref={inputRef}
              {...rest}
            />
            {rest.error && (
              <div className='fv-plugins-message-container text-danger'>
                <div
                  className='fv-help-block'
                  style={{
                    margin: '5px 0 5px 0 ',
                  }}
                >
                  {rest.error}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export const Input2: React.FC<InputProps> = ({...rest}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <div className='row mb-3'>
      <label className={`col-lg-4 col-form-label fw-bold  ${rest.required ? 'required' : ''}`}>
        {rest.title}
      </label>

      <div className='col-lg-8 fv-row'>
        <input
          type={rest.type}
          className='form-control form-control-lg form-control-solid p-1 ps-5'
          size={100}
          ref={inputRef}
          {...rest}
        />
        {rest.error && (
          <div className='text-danger text-center fs-9 fw-bold '>
            <div
              className='fv-help-block'
              style={{
                margin: '5px 0 5px 0 ',
              }}
            >
              {rest.error}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export const Input3: React.FC<InputProps> = ({...rest}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <>
      <label className={`col-form-label fw-bold  ${rest.required ? 'required' : ''}`}>
        {rest.title}
      </label>

      <input
        type={rest.type}
        className='form-control form-control-lg form-control-solid'
        size={100}
        ref={inputRef}
        {...rest}
      />
      {rest.error && (
        <div className='fv-plugins-message-container text-danger'>
          <div
            className='fv-help-block'
            style={{
              margin: '5px 0 5px 0 ',
            }}
          >
            {rest.error}
          </div>
        </div>
      )}
    </>
  )
}

export const Input4: React.FC<InputProps> = ({...rest}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <div className='row mb-3 align-items-center'>
      <label className={`col-lg-2 col-form-label fw-bold  ${rest.required ? 'required' : ''}`}>
        {rest.title}
      </label>

      <div className='col-lg-10 d-flex'>
        <input
          type={rest.type}
          className='form-control form-control-sm form-control-solid mb-3 mb-lg-0'
          size={100}
          ref={inputRef}
          {...rest}
        />
        {rest.error && (
          <div className='text-danger text-center fs-9 fw-bold ml-2'>{rest.error}</div>
        )}
      </div>
    </div>
  )
}
